import { CommonModule, Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, WritableSignal, signal, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PageComponent } from 'src/app/layout/pages/page/page.component';
import { IElaborazione } from '../models/elaborazione.model';
import { ElaborazioneService } from '../elaborazione.service';
import { PageDetailComponent } from 'src/app/layout/pages/page-detail/page-detail.component';
import { EditableCardComponent } from 'src/app/shared/components/cards/editable-card/editable-card.component';
import { TextFieldComponent } from 'src/app/shared/components/fields/text-field/text-field.component';
import { ActivatedRoute } from '@angular/router';
import { ControlliService } from '../../controlli/controlli.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
@Component({
  selector: 'app-elaborazioni-dettaglio-page',
  standalone: true,
  imports: [
    CommonModule,
    PageDetailComponent,
    EditableCardComponent,
    TextFieldComponent,
    MatProgressSpinnerModule
  ],
  templateUrl: './elaborazioni-dettaglio-page.component.html',
  styleUrl: './elaborazioni-dettaglio-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ElaborazioniDettaglioPageComponent implements OnInit {
  @Input() idElaborazione!: any;

  form: FormGroup;
  model: WritableSignal<IElaborazione | undefined> = signal(undefined);
  reload: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private readonly fb: FormBuilder,
    public readonly elaborazioneService: ElaborazioneService,
    private readonly route: ActivatedRoute,
    private readonly controlliService: ControlliService,
    private dialogService: DialogService,
    private location: Location,
  ) {
    this.form = this.fb.group({})
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.idElaborazione = params.get('id')
    })
  }
  checkEliminazione(id_elaborazione:any){
    console.log('ciaoooo', id_elaborazione)
    this.elaborazioneService.isCheckingElaborazione.set(true);
    this.startCheckingSaving(id_elaborazione)
  }
  startCheckingSaving (idElaborazione:string) {
    const intervalID = setInterval(() => {
      this.controlliService.checkElaborazioneFile(idElaborazione).subscribe((checkControllo:any) => {
        console.log(checkControllo)
        if (checkControllo?.error) {
          this.dialogService.success("Errore durante l'eliminazione del file sui server di AnTeA.", false);
          clearInterval(intervalID); // Chiudi l'intervallo
          this.elaborazioneService.isCheckingElaborazione.set(false);
          this.location.back();
       
        }
        if(checkControllo?.statoElaborazione.trim()=='ERRORE') {
          this.dialogService.error(`Errore durante l'eliminazione del file sui server di AnTeA.: ${checkControllo?.note}.`, false);
          clearInterval(intervalID); // Chiudi l'intervallo
          this.elaborazioneService.isCheckingElaborazione.set(false);
          this.location.back();

        }
        if (checkControllo?.statoElaborazione=='ELABORAZIONE_ELIMINATA') {
          this.dialogService.success("Errore durante l'eliminazione del file sui server di AnTeA.", false);
          clearInterval(intervalID); // Chiudi l'intervallo
          this.elaborazioneService.isCheckingElaborazione.set(false);
          this.location.back();
      
        }
    
      });
    }, 5000); // 5000 millisecondi = 5 secondi
  }
}
